import {Navigate} from "react-router-dom";
import React from "react";

const ProtectedRoute = ({target, userAccess, children}: any) => {
    const isAuth = localStorage.getItem("loggedIn");
    const userType = localStorage.getItem("userType");
    if (isAuth !== 'true') {
        return <Navigate to={target} replace/>
    } else {
        return userAccess === userType ? children : <Navigate to={target} replace/>;
    }
}

export default ProtectedRoute;